import { getReporteClientesIntentoRegistro } from "../services/binnacleService"
const dataInicial = {
    clientes: [],
    total: 0,
    pagina: 0,
    registroPagina: 10,
    exito: 0,
}
const GET_REPORTE_CLIENTES_ALL = "GET_REPORTE_CLIENTES_ALL"
const GET_REPORTE_CLIENTES_REGISTROS_PAGINA = "GET_REPORTE_CLIENTES_REGISTROS_PAGINA"
const GET_REPORTE_CLIENTES_PAGINA = "GET_REPORTE_CLIENTES_PAGINA"
const CLEAR_REPORTE_CLIENTES_STATE = "CLEAR_REPORTE_CLIENTES_STATE"
export default function reporteClientesReducer(state = dataInicial, action) {
    switch (action.type) {
        case GET_REPORTE_CLIENTES_PAGINA:
            return {
                ...state,
                clientes: action.payload.clientes,
                total: action.payload.total,
                pagina: action.payload.pagina,
            }
        case GET_REPORTE_CLIENTES_REGISTROS_PAGINA:
            return {
                ...state,
                clientes: action.payload.clientes,
                total: action.payload.total,
                registroPagina: action.payload.registroPagina
            }
        case GET_REPORTE_CLIENTES_ALL:
            return {
                ...state,
                clientes: action.payload.clientes,
                total: action.payload.total
            };
        case CLEAR_REPORTE_CLIENTES_STATE:
            return {
                ...state,
                clientes: action.payload.clientes
            }
        default:
            return state;
    }
}

export const obtenerReporteClientesRegistrohAction = () => async (dispatch, getSate) => {
    const { pagina, registroPagina } = getSate().reporteClientes
    return await getReporteClientesIntentoRegistro({ pagina: pagina + 1, registros: registroPagina }).then(Response => {
        dispatch({
            type: GET_REPORTE_CLIENTES_ALL,
            payload: {
                clientes: Response.lBitacoraCliente,
                total: Response.total
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerReporteClientesRegistrohRegistrosAction = ({ Registros }) => async (dispatch, getSate) => {
    const { pagina } = getSate().reporteClientes
    return await getReporteClientesIntentoRegistro({ pagina: pagina + 1, registros: Registros }).then(Response => {
        dispatch({
            type: GET_REPORTE_CLIENTES_REGISTROS_PAGINA,
            payload: {
                clientes: Response.lBitacoraCliente,
                total: Response.total,
                registroPagina: Registros,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerReporteClientesRegistrohPaginaAction = ({ Pagina }) => async (dispatch, getSate) => {
    const { registroPagina } = getSate().reporteClientes
    return await getReporteClientesIntentoRegistro({ pagina: Pagina + 1, registros: registroPagina }).then(Response => {
        dispatch({
            type: GET_REPORTE_CLIENTES_PAGINA,
            payload: {
                clientes: Response.lBitacoraCliente,
                total: Response.total,
                pagina: Pagina,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const clearState = () => (dispatch) => {
    dispatch({
        type: CLEAR_REPORTE_CLIENTES_STATE,
        payload: {
            dataInicial,
        },
    });
}